import { Injectable } from "@angular/core"
import { Project } from "@tr/models"
import { BehaviorSubject, Subscription } from "rxjs"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class DataService {
  public uid = new BehaviorSubject<string>("")
  public company = new BehaviorSubject<string>("")
  public project = new BehaviorSubject<string>("")
  public projectData = new BehaviorSubject<Project>(null)
  public email = new BehaviorSubject<string>("")
  public displayName = new BehaviorSubject<string>("")
  public firstName = new BehaviorSubject<string>("")
  public lastName = new BehaviorSubject<string>("")
  public isCreditLimit = new BehaviorSubject<boolean>(false)
  public creditLimit = new BehaviorSubject<number>(200000)
  public photoUrl = new BehaviorSubject<string>("")
  public totalTestCases = new BehaviorSubject<number>(0)
  public creditsRemaining = new BehaviorSubject<number>(0)
  public currentTestCount = new BehaviorSubject<number>(0)
  public lastRunId = new BehaviorSubject<string>("")
  public totalBugs = new BehaviorSubject<number>(0)
  public totalPassed = new BehaviorSubject<number>(0)
  public totalFailed = new BehaviorSubject<number>(0)
  public totalIncomplete = new BehaviorSubject<number>(0)
  public totalBlocked = new BehaviorSubject<number>(0)
  public roles = new BehaviorSubject<string[]>([])

  private projectSubscription: Subscription

  constructor(private firebaseService: FirebaseService) {}

  public async changeProjectAndResubscribe(projectId: string, storeSessionData?: () => void): Promise<void> {
    if (!projectId || (this.projectSubscription && this.project.value === projectId)) { return }

    this.project.next(projectId)
    if (projectId) {
      if (this.projectSubscription) {
        this.projectSubscription.unsubscribe()
      }

      const projectRef = this.firebaseService
        .collection("companies")
        .doc(this.company.value)
        .collection("projects")
        .doc<Project>(projectId)

      this.projectSubscription = projectRef
        .valueChanges()
        .subscribe(project => this.updateProjectData(project))
      this.updateProjectData((await projectRef.ref.get()).data() as Project, storeSessionData)
    }
  }

  public updateProjectData(project: Project, storeSessionData?: () => void): void {
    if (project) {
      this.projectData.next(project)
      this.currentTestCount.next(project.currentTestCount || 0)
      this.totalTestCases.next(project.totalTestCases || 0)
      this.totalFailed.next(project.totalFailed || 0)
      this.totalPassed.next(project.totalPassed || 0)
      this.totalBugs.next(project.totalBugs || 0)
      this.lastRunId.next(project.lastRunId || "")
    }

    if (storeSessionData) {
      storeSessionData()
    }
  }

  public clearData(): void {
    this.uid.next("")
    this.company.next("")
    this.project.next("")
    this.projectData.next(null)
    this.email.next("")
    this.displayName.next("")
    this.firstName.next("")
    this.lastName.next("")
    this.isCreditLimit.next(false)
    this.creditLimit.next(200000)
    this.photoUrl.next("")
    this.totalTestCases.next(0)
    this.creditsRemaining.next(0)
    this.currentTestCount.next(0)
    this.lastRunId.next("")
    this.totalBugs.next(0)
    this.totalPassed.next(0)
    this.totalFailed.next(0)
    this.totalIncomplete.next(0)
    this.totalBlocked.next(0)
    this.roles.next([])
  }
}
